import http from '@/assets/common/http';
// ------------------------------------------结算管理
// ------------------------------------------查询供应商结算
export function addOrderFun(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询供应商结算详情
export function addOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取供应商名称
export function supplierName() {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// ----------------------------------------新-------------获取供应商名称
export function newSupplierName() {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// -----------------------------------------供应商菜品订单详情
export function supplierDayDetail(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------查询团餐公司结算
export function tcOrderFun(data) {
  const params = {
    // SERVICE_ID: '10026',
    // OTYPE: 6,
    SERVICE_ID: '10011',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取团餐公司名称
export function tcName() {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// ----------------------------------------获取项目点名称
export function getTitle(data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取团餐公司项目点名称
export function getTCTitle(data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 5,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------结算导出
export function exportSettlementFun(data) {
  const params = {
    SERVICE_ID: '10011',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------导出月收入
export function exportMonthFun(data) {
  const params = {
    SERVICE_ID: '10011',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------导出成本表
export function exportCostFun(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------上传发票
export function addInvoice(data) {
  const params = {
    SERVICE_ID: '10015',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取发票
export function getInvoiceFun(data) {
  const params = {
    SERVICE_ID: '10015',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------删除发票
export function delInvoiceFun(data) {
  const params = {
    SERVICE_ID: '10015',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------查询企业（团餐/客户）结算详情
export function OrderDetailFun(data) {
  const params = {
    // SERVICE_ID: '10026',
    // OTYPE: 8,
    SERVICE_ID: '10009',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------查询企业（团餐/客户）结算详情
export function TCOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取团餐公司发票详情
export function queryTCInvoiceFun(data) {
  const params = {
    SERVICE_ID: '10018',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------导出团餐公司发票详情
export function exportTCInvoiceFun(data) {
  const params = {
    SERVICE_ID: '10018',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------导出供应商发票详情
export function exportGYSInvoiceFunFun(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------获取供应商开票明细
export function exportGYSInvoiceFun(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------自录客户寄单
export function sendOrderFun(data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------查询自录客户订单资质
export function queryOrderContractFun(data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------上传自录客户订单资质
export function addOrderContractFun(data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------删除自录客户订单资质
export function delOrderContractFun(data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------查询菜品（团餐/客户）详情
export function dayDetail(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 9,
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------查询自录客户结算
export function customerOrderFun(data) {
  const params = {
    // SERVICE_ID: '10026',
    // OTYPE: 7,
    SERVICE_ID: '10009',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------获取客户名称
export function customerName() {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// -----------------------------------新---------获取客户名称
export function newCustomerName() {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// -------------------------------------导出供应商结算
export function exportSupplierBalanceFun(data) {
  const params = {
    SERVICE_ID: '10026',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------导出对账单
export function exportOrder(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 44,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------按照不同价格汇总
export function exportTCInvoicePriceFun(data) {
  const params = {
    SERVICE_ID: '10018',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/tcBanlance.js